import { FC } from 'react';
import { Span } from 'atoms/Typography';
import { useProductSizeSort } from 'pages/ProductDetail/hooks/useProductSizeSort';
import { IAdaptedProduct } from 'commerce/scayle/utils/adapter/types';
import styles from './styles.module.css';

interface IProps {
  size?: IAdaptedProduct['size'];
}

export const ProductSize: FC<IProps> = ({ size = [] }) => {
  const { sizeSort } = useProductSizeSort();

  if (!size.length) {
    return null;
  }

  const sortedSizes = size.sort(sizeSort);

  const availableSizes = sortedSizes.filter((item) => item.stock > 0);

  if (!availableSizes.length) {
    return null;
  }

  const [smallestSize] = availableSizes;
  const largestSize = availableSizes[availableSizes.length - 1];

  return (
    <span className={styles.productSizes}>
      <Span key={smallestSize.label} className={styles.productMaterial}>
        {smallestSize.label === largestSize.label
          ? smallestSize.label
          : `${smallestSize.label} - ${largestSize.label}`}
      </Span>
    </span>
  );
};
